import Shoe from "../pages/ShoeV5.jsx";
import Overview from "../pages/Overview.jsx";
import Quiz from "../pages/QuizV3.js";
import NotificationsPage from "../pages/NotificationsPage.js";
import HowTo from "../pages/HowTo.js";
import Likes from "../pages/Likes.js";
import Discover from "../pages/Discover.js";
import Popular from "../pages/Popular.js";
import ColorwayPage from "../pages/ColorwayPage.js";
import Helper from "../functions/Helper.js";
import UserRating from "../pages/UserRating.js";
import Login from "../pages/Login.js";
import Account from "../pages/Account.js";
import Critic from "../pages/Critic.js";
import User from "../pages/User.js";
import UserReviews from "../pages/UserReviews.js";
import Navigation from "../pages/NavigationV2.js";
import { Outlet, ScrollRestoration } from "react-router-dom";
import querystring from "query-string";
import RouterChanges from "../components/RouterChangesV2.js";

import Rollbar from "rollbar";
import { useRouteError } from "react-router-dom";

import * as React from "react";

const Layout = () => {
  return (
    <>
      <RouterChanges />
      <Navigation />

      <Outlet />
      <ScrollRestoration />
    </>
  );
};

const ErrorDisplay = () => {
  let rollbarConfig = {
    accessToken: "207b0cae5369443a8c604ffb6bc80e2b",
    payload: {
      environment: "Shoe Reviews Frontend Web",
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: __COMMIT_HASH__,
          guess_uncaught_frames: true,
        },
      },
    },
  };

  const rollbar = new Rollbar(rollbarConfig);
  let error = useRouteError();
  rollbar.error(error);

  return (
    <div>
      <h1>Something went wrong.</h1>
      <div>Try refreshing the browser</div>
    </div>
  );
};

const routes = (store, actions, globalData) => [
  {
    path: "shoe-reviews/",
    element: <Layout />,
    errorElement: <ErrorDisplay />,
    loader: async ({ params, request }) => {
      if (typeof window !== "undefined") {
        return null;
      }
      let queryString = request.url.split("?")[1] ?? "";

      const paginatedDataResponse = await fetch(
        __server__ + "/API/pub/filter?" + queryString,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const paginatedData = await paginatedDataResponse.json();

      const filterObject = querystring.parse(queryString);
      store.dispatch(actions.filterObject(filterObject));
      store.dispatch(actions.initial_data({ ...paginatedData }));

      return {
        filterObject,
        paginatedData,
      };
    },

    children: [
      {
        path: "popular",
        element: <Popular />,
        loader: async () => {
          let popularStyles = await fetch(
            __server__ + "/API/pub/popular_styles?limit=100"
          )
            .then((response) => response.json())
            .then((data) => {
              return data;
            });

          return popularStyles;
        },
      },
      {
        path: "critic",
        element: <Critic />,
      },
      {
        path: "user",
        element: <User />,
      },
      {
        path: "quiz",
        element: <Quiz />,
      },
      {
        path: "discover",
        element: <Discover />,
      },

      {
        path: "notifications",
        element: <NotificationsPage />,
      },
      {
        path: "how-does-it-work",
        element: <HowTo />,
      },
      {
        path: "likes",
        element: <Likes />,
      },
      {
        path: "rating",
        element: <UserRating />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "account",
        element: <Account />,
      },
      {
        path: "user-reviews",
        element: <UserReviews />,
      },

      //mapped urls like nike-basketball-shoes etc.
      ...globalData.urlMapping.map((url) => {
        //path should use regext to get the string between "/shoe-reviews/" and the next "/"
        let path = url.url.split("/shoe-reviews/")[1];

        return {
          path: path,
          element: <Overview />,
        };
      }),

      //Shoe Pages
      ...globalData.overview.map((shoe) => ({
        path: shoe.url,
        element: <Shoe key={shoe.url} url={shoe.url} />,
        loader: async () => {
          if (typeof window !== "undefined") {
            return null;
          }
          let shoeData = await Helper.fetchShoeData(shoe.url.toLowerCase());

          store.dispatch(actions.shoeData(shoeData));

          return { shoeData };
        },
      })),

      //Colorways per Shoe
      ...globalData.overview.map((shoe) => ({
        path: shoe.url + "-colorways",
        element: <ColorwayPage url={shoe.url} />,
        loader: async () => {
          if (typeof window !== "undefined") {
            return null;
          }
          let shoeData = await Helper.fetchShoeData(shoe.url.toLowerCase());

          store.dispatch(actions.shoeData(shoeData));

          return { shoeData };
        },
      })),

      {
        path: "*",
        element: <div> 404 </div>,
      },

      {
        index: true,
        element: <Overview />,
      },
    ],
  },
];

/*
const routes = [
  {
    path: "/shoe-reviews",
    component: <div> test </div>,
    exact: true,
    filterObject: true,
  },
  {
    path: "/shoe-reviews(/.*basketball-shoes)?",
    component: Overview,
    exact: true,
    filterObject: true,
  },
  /*{
    path: '/shoe-reviews/*basketball-shoes',
    component: Overview,
    exact:true,
  },
  {
    path: "/shoe-reviews/popular/",
    component: Popular,
    fetchToDo: "popular",
    fetchData: () => {
      return fetch(__server__ + "/API/pub/popular_styles?limit=100")
        .then((response) => response.json())
        .then((data) => {
          return data;
        });
    },
  },
  {
    path: "/shoe-reviews/critic",
    component: Critic,
  },
  {
    path: "/shoe-reviews/user",
    component: User,
  },
  {
    path: "/shoe-reviews/quiz",
    component: Quiz,
  },
  {
    path: "/shoe-reviews/discover",
    component: Discover,
  },
  {
    path: "/shoe-reviews/coupons",
    component: CouponPage,
  },
  {
    path: "/shoe-reviews/notifications",
    component: NotificationsPage,
  },
  {
    path: "/shoe-reviews/how-does-it-work",
    component: HowTo,
  },
  {
    path: "/shoe-reviews/likes",
    component: Likes,
  },
  {
    path: "/shoe-reviews/rating",
    component: UserRating,
  },
  {
    path: "/shoe-reviews/login",
    component: Login,
  },
  {
    path: "/shoe-reviews/account",
    component: Account,
  },
  {
    path: "/shoe-reviews/user-reviews",
    component: UserReviews,
  },

  {
    path: "/shoe-reviews/:shoe_name-colorways",
    component: ColorwayPage,
    fetchToDo: "shoe",
    fetchData: (params) => {
      return Helper.fetchShoeData(params.shoe_name.toLowerCase());
    },
  },

  {
    path: "/shoe-reviews/:shoe_name",
    component: Shoe,
    fetchToDo: "shoe",
    fetchData: (params) => {
      return Helper.fetchShoeData(params.shoe_name.toLowerCase());
    },
  },
];

*/

export default routes;
